// convert hex to rgb
const hexToRgb = (hex, alpha) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16
      )}, ${alpha})`
    : null;
};

const colors = [
  "#3F51B5",
  "#2196F3",
  "#9F2B68",
  "#3F51B5",
  "#00A8FF",
  "#FFC107",
  "#FF5722",
  "#F44336",
  "#4CAF50",
  "#FF9800",
];

export const homeColors = [
  "#1D8578",
  "#58A4B5",
  "#7F5AC3",
  "#B83A60",
  "#71A563",
  "#9D6CC3",
  "#3661CE",
  "#D96F41",
  "#C63D3D",
  "#78879E",
];

const getBackgroundColor = (value = "1", opacity) => {
  const color = homeColors[value[0].charCodeAt(0) % homeColors.length];
  if (opacity) {
    return hexToRgb(color, opacity);
  }
  return color;
};
export default getBackgroundColor;
